import axios from "axios";

function createSpaxios() {
  return axios.create({
    withCredentials: true
  });
}

export const spaxios = createSpaxios();
